export const conditionalClass = (className: string, condition: boolean) => {
	if (condition) return className

	return ""
}
export const concatClassNames = (
	classes: Array<string | boolean | undefined>
) => {
	return classes.filter(Boolean).join(" ")
}
